import { type FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { useGetPartnersTaskQuery } from '@/api/queries/user';
import { LightColorEffect } from '@/components/common/LightColorEffect/LightColorEffect';
import { H1, TextSmall } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';

import { SocialList } from '../SocialNetworks/Socials/SocialList';

import { PromoCodeForm } from './PromoCodeForm/PromoCodeForm';

import css from './styles.module.scss';

import promoCardPng from '/img/promo/promo-card.png';
import promoCardWebp from '/img/promo/promo-card.webp';

const PromoCodeTab: FC = () => {
  const { t } = useTranslation();
  useGetPartnersTaskQuery();

  return (
    <article className={css.promoCodeTab}>
      <H1
        weight="bold"
        className="!text-xl !leading-none max-w-[12.75rem] text-center mb-5"
      >
        {t('Activate promo code and get reward')}
      </H1>
      <div className={css.promoCardWrapper}>
        <LightColorEffect
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[20rem] -z-[1]"
          lightClassName={css.lightColor}
        />
        <Picture
          className="w-full"
          img={promoCardPng}
          webp={promoCardWebp}
          alt="promo card"
        />
      </div>
      <PromoCodeForm />
      <TextSmall className="!text-white/60 !leading-1.2 max-w-[18.1875rem] text-center mb-4">
        <Trans
          i18nKey={
            'Find codes on our social networks <br /> and get valuable rewards'
          }
          components={{ br: <br /> }}
        />
      </TextSmall>
      <SocialList />
    </article>
  );
};

export { PromoCodeTab };
